<template>
    <div class="policies">
        <div class="payment">
            <template v-if="offer.policies.paymentType == 'guarantee'">
                <div class="highlight">Reserve now, pay later</div>
            </template>
            <template v-if="offer.policies.paymentType == 'deposit'"></template>
            <template v-if="offer.policies.paymentType == 'prepay'"></template>
        </div>

        <template v-if="offer.policies.cancellation">
            <div v-if="cancellation(this.offer.policies.cancellation.deadline)" class="cancellation">
                <div v-if="offer.policies.cancellation.type == 'FULL_STAY'" class="highlight">
                    Fully refundable
                    <template v-if="cancellation(this.offer.policies.cancellation.deadline) && showCancellationDate">
                        before {{ cancellation(this.offer.policies.cancellation.deadline) }}
                    </template>
                </div>
                <div v-else-if="offer.policies.cancellation.type == 'Flat'"></div>
                <div v-else-if="offer.policies.cancellation.type == 'FlatPerNight'"></div>
                <div v-else-if="offer.policies.cancellation.type == 'StayPercent'"></div>
                <div v-else-if="offer.policies.cancellation.type == 'FirstNight'"></div>
                <div v-else-if="offer.policies.cancellation.type == 'LastNight'"></div>
                <div v-else-if="offer.policies.cancellation.type == 'FirstAndLastNight'"></div>
                <div v-else class="highlight">
                    Fully refundable
                    <template v-if="cancellation(this.offer.policies.cancellation.deadline) && showCancellationDate">
                        before {{ cancellation(this.offer.policies.cancellation.deadline) }}
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc'

    dayjs.extend(utc);

    export default {
        name: 'PolicyType',
        props: {
            offer: {
                type: Object,
                required: true
            },
            showCancellationDate: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            cancellation(deadline) {
                if (deadline) {
                    var now = dayjs.utc();
                    var date = dayjs(deadline);

                    if (date > now) {
                       return date.local().format('DD-MM-YYYY HH:mm');
                    }
                }

                return false;
            }
        }
    }
</script>

<style scoped>
    .highlight{
        color:#066706;
    }
</style>
